package br.com.texeratx.boardgametimeapp.data.model.match

import kotlinx.serialization.Serializable

@Serializable
data class CreateMatchRequest(
    val clanGameId: Long,
    val date: String,
    val duration: Int,
    val observation: String? = null,
    val scores: List<CreateMatchScoreRequest>,
    val clanExpansionIds: List<Long> = emptyList()
)

@Serializable
data class CreateMatchScoreRequest(
    val playerId: Long,
    val points: Double
)
